import { ThemeOptions, PaletteOptions } from '@mui/material/styles';
import { createBreakpoints } from '@mui/system';
import { MuiCssBaseline } from './components/MuiCssBaseline';
import { tannerBlack, tannerBlue, tannerGray, tannerWhite } from './colors';
import { MuiAlert } from './components/MuiAlert';
import { MuiAutocomplete } from './components/MuiAutocomplete';
import { MuiAvatar } from './components/MuiAvatar';
import { MuiBadge } from './components/MuiBadge';
import {
  MuiButton,
  MuiButtonBase,
  MuiButtonGroup,
} from './components/MuiButton';
import { MuiBreadcrumbs } from './components/MuiBreadcrumbs';
import { MuiCard, MuiCardActions, MuiCardContent } from './components/MuiCard';
import { MuiCheckbox } from './components/MuiCheckbox';
import { MuiChip } from './components/MuiChip';
import {
  MuiDialog,
  MuiDialogActions,
  MuiDialogContent,
  MuiDialogTitle,
} from './components/MuiDialog';
import { MuiDrawer } from './components/MuiDrawer';
import { MuiFab } from './components/MuiFab';
import { MuiFormLabel } from './components/MuiFormLabel';
import { MuiGrid } from './components/MuiGrid';
import { MuiIconButton } from './components/MuiIconButton';
import {
  MuiFilledInput,
  MuiInput,
  MuiInputBase,
  MuiInputLabel,
} from './components/MuiInput';
import { MuiLinearProgress } from './components/MuiLinearProgress';
import { MuiLink } from './components/MuiLink';
import { MuiList } from './components/MuiList';
import { MuiMenuItem } from './components/MuiMenuItem';
import { MuiPaginationItem } from './components/MuiPaginationItem';
import { MuiPaper } from './components/MuiPaper';
import { MuiPopover } from './components/MuiPopover';
import { MuiRadio } from './components/MuiRadio';
import { MuiSelect } from './components/MuiSelect';
import { MuiSkeleton } from './components/MuiSkeleton';
import { MuiSwitch } from './components/MuiSwitch';
import { MuiSvgIcon } from './components/MuiSvgIcon';
import { MuiTab, MuiTabs } from './components/MuiTab';
import { MuiTextField } from './components/MuiTextField';
import { MuiTooltip } from './components/MuiTooltip';
import { MuiTypography } from './components/MuiTypography';

const breakpoints = createBreakpoints({
  values: {
    xs: 0,
    sm: 361,
    md: 768,
    lg: 960,
    xl: 1200,
  },
});

const themeOptions: ThemeOptions & {
  palette: PaletteOptions & {
    white: { main: string };
    black: { main: string };
    blue: { main: string };
  };
} = {
  typography: {
    htmlFontSize: 14,
    fontSize: 14,
    fontFamily: '"Noto Sans", sans-serif',
    fontWeightRegular: 500,
  },
  spacing: [0, 2, 4, 8, 12, 16, 24, 32],
  breakpoints,
  palette: {
    background: { default: tannerWhite, paper: tannerWhite },
    text: { primary: tannerBlack },
    primary: {
      main: tannerBlue['500'],
    },
    secondary: { main: tannerGray['200'] },
    error: { main: '#D70E16' },
    white: {
      main: tannerWhite,
    },
    black: {
      main: tannerBlack,
    },
    blue: {
      main: tannerBlue['500'],
    },
  },
  components: {
    MuiCssBaseline,
    MuiAlert,
    MuiAutocomplete,
    MuiAvatar,
    MuiBadge,
    MuiButtonBase,
    MuiButton,
    MuiButtonGroup,
    MuiBreadcrumbs,
    MuiCard,
    MuiCardActions,
    MuiCardContent,
    MuiCheckbox,
    MuiChip,
    MuiDialog,
    MuiDialogActions,
    MuiDialogContent,
    MuiDialogTitle,
    MuiDrawer,
    MuiFab,
    MuiFormLabel,
    MuiGrid,
    MuiIconButton,
    MuiInputBase,
    MuiInput,
    MuiFilledInput,
    MuiInputLabel,
    MuiLinearProgress,
    MuiLink,
    MuiList,
    MuiMenuItem,
    MuiPaginationItem,
    MuiPaper,
    MuiPopover,
    MuiRadio,
    MuiSelect,
    MuiSkeleton,
    MuiSwitch,
    MuiSvgIcon,
    MuiTab,
    MuiTabs,
    MuiTextField,
    MuiTooltip,
    MuiTypography,
  },
};

export default themeOptions;
